import IM from './IM.vue'

IM.install = function (Vue) {
  Vue.component(IM.name, IM)
}

export default IM
